import React, { useContext } from 'react';
import useFormProcessor from '../../hooks/useFormProcessor';

import { Context } from '../../providers/global-context.provider';
import { SprintsContext } from '../../providers/sprints-context.provider';

import { validateGoal, validateTitle, validateStartDate, validateEndDate } from '../../utils/validations/sprints';
import { getEmptyInputsErrorsObject } from '../../utils/errors/sprints';

import DateInputs from '../date-inputs-container';
import ErrorMessageContainer from '../form-input-error-message';
import IssueFormsInput from '../issue-forms-input';
import CustomLabel from '../label';
import FormInput from '../form-input';

const initialError = { Title: '', Goal: '', StoryPoints: '',BaleId: '' };

const SprintForm = ({ handleUpdateSprint, children, showDateInputs, successFunc = null }) => {
	const { toggleModalIsOpen } = useContext(Context);
	const { currentSprint } = useContext(SprintsContext);
	const { data, errors, setErrors, setData, handleChange, handleOnBlur, handleSubmit } = useFormProcessor(
		initialError,
		currentSprint.Goal ? currentSprint : { ...currentSprint, Goal: '' }
	);

	const getErrors = () => {
		const { Title, Goal, StartDate, EndDate, BaleId } = data;
		const errorObj = showDateInputs ? { Title, Goal, StartDate, EndDate, BaleId } : { Title, Goal };
		return getEmptyInputsErrorsObject(errorObj);
	};

	const updateSprint = async () => {
		const success = await handleUpdateSprint(data);

		if (success) {
			setErrors({ name: '', key: '' });
			toggleModalIsOpen();
			if (successFunc) {
				successFunc();
			}
		}
	};

	const renderDateInputs = () => {
		return (
			<DateInputs
				data={data}
				errors={errors}
				setErrors={setErrors}
				setData={setData}
				startDateOnBlur={(event) => handleOnBlur(event, validateStartDate, { StartDate: data.StartDate })}
				endDateOnBlur={(event) => handleOnBlur(event, validateEndDate, { EndDate: data.EndDate })}
			/>
		);
	};

	return (
		<form
			onSubmit={(e) => handleSubmit(e, getErrors(), updateSprint)}
			className="container px-5 py-2 mx-auto"
			onKeyPress={(e) => {
				e.key === 'Enter' && e.preventDefault();
			}}
		>
			<div className="flex flex-col text-center w-full mb-4">
				<p className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">ویرایش اسپرینت</p>
			</div>
			<div className="lg:w-2/3 md:w-2/3 mx-auto">
				<div className="flex flex-wrap -m-2">
					<div className="p-2 w-4/6">
						<CustomLabel labelFor="Title">نام اسپرینت</CustomLabel>
						<IssueFormsInput
							handleChange={handleChange}
							handleOnBlur={(event) => handleOnBlur(event, validateTitle, { Title: data.Title })}
							placeholder="نام اسپرینت"
							type="text"
							name="Title"
							value={data.Title}
						/>
						{errors.Title ? <ErrorMessageContainer>{errors.Title}</ErrorMessageContainer> : null}
					</div>
					{showDateInputs ? (
						<div>
							<div className="p-2 w-4/6">
								{renderDateInputs()}
							</div>
							<div className="p-2 w-4/6">
								<FormInput
									className="focus:outline-none p-1 pl-2 text-base text-gray-600 leading-normal"
									type="text"
									name="BaleId"
									placeholder="شناسه گروه"
									value={data.BaleId}
									handleChange={handleChange}
								/>
							</div>
						</div>
					) : null}
					<div className="p-2 w-full">
						<CustomLabel labelFor="Goal">هدف</CustomLabel>
						<textarea
							onChange={handleChange}
							onBlur={(event) => handleOnBlur(event, validateGoal, { Goal: data.Goal })}
							name="Goal"
							className="w-full bg-gray-100 rounded border border-gray-400 focus:outline-none h-24 focus:border-teal-500 text-base px-4 py-2 resize-none block"
							placeholder="هدف از اسپرینت"
							value={data.Goal}
						/>
						{errors.Goal ? <ErrorMessageContainer>{errors.Goal}</ErrorMessageContainer> : null}
					</div>

					<div className="p-2 w-full">{children}</div>
				</div>
			</div>
		</form>
	);
};

export default SprintForm;
